var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"layout-footer footer",class:_vm.getLayoutFooterBg()},[_c('div',{staticClass:"container-fluid container-p-x"},[_c('span',{staticClass:"small text-muted float-right my-1"},[_vm._v("Versión "+_vm._s(_vm.version))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }